import { Facebook, Globe, Instagram, Linkedin, Phone, Twitter, Youtube } from "lucide-react";
import type { ComponentType } from "react";
import { CallLink } from "../calls/CallTracker";

// LDF: klickbare Telefonnummern (tel:) und Social-Media-Links.

export const telHref = (number: string) => {
  let digits = number.replace(/\(0\)/g, "").replace(/[^\d+]/g, "");
  if (digits.startsWith("00")) digits = `+${digits.slice(2)}`;
  return `tel:${digits}`;
};

export const PhoneLink = ({
  number,
  label,
  disabled,
  name,
  companyId,
}: {
  number: string;
  label?: string;
  disabled?: boolean;
  name?: string;
  companyId?: number | string | null;
}) => (
  <div className="flex flex-row items-center gap-1 min-h-[24px]">
    <Phone className="w-4 h-4 shrink-0" />
    {disabled ? (
      <span className="text-sm text-muted-foreground line-through" title="Kontaktsperre">
        {number}
      </span>
    ) : (
      <CallLink number={number} name={name ?? number} companyId={companyId} className="text-sm underline hover:no-underline" />
    )}
    {label && label !== "Telefon" && <span className="text-xs text-muted-foreground">{label}</span>}
  </div>
);

type Social = { name: string; icon: ComponentType<{ className?: string }>; test: RegExp };

const SOCIALS: Social[] = [
  { name: "Instagram", icon: Instagram, test: /instagram\.com/i },
  { name: "Facebook", icon: Facebook, test: /facebook\.com|fb\.com/i },
  { name: "X / Twitter", icon: Twitter, test: /(^|\/\/|\.)(twitter\.com|x\.com)/i },
  { name: "LinkedIn", icon: Linkedin, test: /linkedin\.com/i },
  { name: "YouTube", icon: Youtube, test: /youtube\.com|youtu\.be/i },
  { name: "TikTok", icon: Globe, test: /tiktok\.com/i },
  { name: "XING", icon: Globe, test: /xing\.com/i },
  { name: "Pinterest", icon: Globe, test: /pinterest\./i },
  { name: "Threads", icon: Globe, test: /threads\.net/i },
  { name: "Vimeo", icon: Globe, test: /vimeo\.com/i },
];

export const socialOf = (url: string) => SOCIALS.find((s) => s.test.test(url));

const handleOf = (url: string) => {
  try {
    const path = new URL(url.startsWith("http") ? url : `https://${url}`).pathname.split("/").filter(Boolean);
    const last = path.filter((p) => !["company", "pages", "in", "user", "channel", "posts"].includes(p))[0];
    return last ? `@${decodeURIComponent(last).replace(/^@/, "")}` : "";
  } catch {
    return "";
  }
};

export const SocialLink = ({ url }: { url: string }) => {
  const social = socialOf(url);
  if (!social) return null;
  const Icon = social.icon;
  const href = url.startsWith("http") ? url : `https://${url}`;
  return (
    <div className="flex flex-row items-center gap-1 min-h-[24px]">
      <Icon className="w-4 h-4 shrink-0" />
      <a className="text-sm underline hover:no-underline truncate" href={href} target="_blank" rel="noopener noreferrer" title={href}>
        {social.name} {handleOf(url)}
      </a>
    </div>
  );
};
